import { useEffect } from 'react';

import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

import type { Dispatch, SetStateAction } from 'react';

interface UseTagsEffectsProps {
  getTagsHandler: () => Promise<void>;
  setHeader: Dispatch<SetStateAction<NHeaderProvider.Header>>;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const useTagsEffects = ({
  getTagsHandler,
  setHeader,
  setIsModalOpen,
}: UseTagsEffectsProps): void => {
  useEffect(() => {
    setHeader({ setIsModalOpen });
  }, [setHeader, setIsModalOpen]);

  useEffect(() => {
    getTagsHandler();
  }, [getTagsHandler]);
};
